/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { EventService } from '../services/event.service';

import { Event } from '../models/event';
import { EventInstance } from '../models/event-instance';
import { InstanceData } from '../models/instance-data';
import { LocationInstance } from '../models/location-instance';
import { ZoneInstance } from '../models/zone-instance';
import { Property } from '../models/property';
import { PropertyType } from '../models/property-type';
import { User } from '../models/user';
import {ObjectInstance} from "../models/object-instance";
import { EventData } from 'app/models/event-data';

declare var $: any;

@Component({
    selector: 'app-event-creation-dialog',
    templateUrl: './event-creation-dialog.component.html'
})
export class EventCreationDialogComponent {
    @Input()
    event: Event;

    eventInstance: EventInstance;

    propertyType = PropertyType;

    constructor(
        public eventService: EventService) { this.event = new Event(); }

    public show(): void {
        this.eventInstance = new EventInstance();
        this.eventInstance.event = this.event;
        this.eventInstance.data = [];

        //
        // create pseudo location/zone/user properties
        const locationProperty = new Property();
        locationProperty.name = "Location";
        locationProperty.property = "_location";
        locationProperty.type = PropertyType.LOCATION_REFERENCE;

        const location = new EventData();
        location.property = locationProperty;
        this.eventInstance.data.push(location);

        const zoneProperty = new Property();
        zoneProperty.name = "Zone";
        zoneProperty.property = "_zone";
        zoneProperty.type = PropertyType.ZONE_REFERENCE;

        const zone = new EventData();
        zone.property = zoneProperty;
        this.eventInstance.data.push(zone);

        const userProperty = new Property();
        userProperty.name = "User";
        userProperty.property = "_user";
        userProperty.type = PropertyType.USER_REFERENCE;

        const user = new EventData();
        user.property = userProperty;
        this.eventInstance.data.push(user);

        const personProperty = new Property();
        personProperty.name = "Person";
        personProperty.property = "_person";
        personProperty.type = PropertyType.OBJECT_REFERENCE;

        const person = new EventData();
        user.property = personProperty;
        this.eventInstance.data.push(person);

        for (const property of this.event.properties) {
            const datum = new EventData();
            datum.property = property;

            this.eventInstance.data.push(datum);
        }

        $("#eventCreationDialog").modal("show");
    }

    public hide(): void {
         $("#eventCreationDialog").modal("hide");
    }

    onGenerate(): void {
        if (this.eventInstance.data[0].value) {
            const location: LocationInstance = new LocationInstance();
            location.id = Number.parseInt(this.eventInstance.data[0].value);
            this.eventInstance.locationInstance = location;
        }

        if (this.eventInstance.data[0].value) {
            const zone: ZoneInstance = new ZoneInstance();
            zone.id = Number.parseInt(this.eventInstance.data[1].value);
            this.eventInstance.zoneInstance = zone;
        }

        if (this.eventInstance.data[0].value) {
            const person: ObjectInstance = new ObjectInstance();
            person.id = Number.parseInt(this.eventInstance.data[2].value);
            this.eventInstance.person = person;
        }

        this.eventService.generateEvent(this.eventInstance);
    }

}
